// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Hp-z","slideIn":"Ip-z"};